var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Row from './Row';
var Timebar = function (props) {
    var time = props.time, rows = props.rows;
    return (_jsx("div", __assign({ className: "rt-timebar" }, { children: rows.map(function (row) {
            var id = row.id, cells = row.cells, style = row.style;
            return _jsx(Row, { time: time, cells: cells, style: style }, id);
        }) })));
};
export default Timebar;
